import poster1 from "./images/pcr.png";
export const JADWAL = {
  dikonfirmasi: false,
  jarakMenit: 30,
  hari: {
    1: { mulai: "07:30", akhir: "11:00" },
    2: { mulai: "07:30", akhir: "11:00" },
    3: { mulai: "07:30", akhir: "11:00" },
    4: { mulai: "07:30", akhir: "11:00" },
    5: { mulai: "07:30", akhir: "11:00" },
    6: { mulai: "07:30", akhir: "10:00" },
  },
};

export const KONTAK_SWAB = {
  telepon: { tampil: "(021) 798 0888", tel: "+62217980888" },
  cs: { tampil: "0811-901-874", wa: "62811901874" },
};
export const PEMERIKSAAN = [
  {
    kode: "PCR",
    nama: { id: "Swab PCR Covid-19", en: "Covid-19 PCR Swab" },
    julukan: { id: "Hasil 2 - 3 jam", en: "Results in 2 - 3 hours" },
    catatan: {
      id: "Dikerjakan di laboratorium khusus PCR RS JMC.",
      en: "Processed in the dedicated PCR laboratory at RS JMC.",
    },
    harga: 255000,
    isi: [],
  },
];
export const GRATIS = [];

export const POSTER = [
  {
    gambar: poster1,
    judul: { id: "Swab PCR Covid-19", en: "Covid-19 PCR Swab" },
    alt: {
      id: "Poster layanan swab PCR Covid-19 RS Jakarta Medical Center.",
      en: "RS Jakarta Medical Center Covid-19 PCR swab service poster.",
    },
  },
];

export const CATATAN = [
  {
    id: "Hasil pemeriksaan dapat ditunggu, sekitar 2 sampai 3 jam.",
    en: "Results can be waited for, in about 2 to 3 hours.",
  },
  {
    id: "Pemeriksaan dikerjakan di laboratorium khusus PCR RS Jakarta Medical Center.",
    en: "Testing is carried out in the dedicated PCR laboratory at RS Jakarta Medical Center.",
  },
];
